import { Heart } from "lucide-react";
import { toast } from "sonner";
import { toggleFavorite, useFavorites } from "@/lib/favorites";

export const FavoriteButton = ({ p, className = "", size = "md" }) => {
  const favs = useFavorites();
  const on = favs.includes(p.id);
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const added = toggleFavorite(p.id);
    toast.success(added ? "Salvo nos favoritos" : "Removido dos favoritos", { duration: 1500 });
  };
  const box = size === "sm" ? "h-8 w-8" : "h-10 w-10";
  return (
    <button type="button" data-testid={`favorite-btn-${p.id}`} aria-pressed={on} aria-label={on ? "Remover dos favoritos" : "Salvar nos favoritos"} onClick={onClick}
      className={`no-invert flex ${box} items-center justify-center rounded-full bg-white text-black shadow-md transition-transform duration-200 active:scale-90 ${className}`}>
      <Heart className={`${size === "sm" ? "h-4 w-4" : "h-5 w-5"} transition-colors ${on ? "fill-red-500 text-red-500" : "text-red-500"}`} strokeWidth={2.2} />
    </button>
  );
};
